export namespace GasForm {
  export enum InputState {
    Default = 'default',
    Primary = 'primary',
    Error = 'error',
    Success = 'success',
  }

  export enum States {
    Disabled = 'DISABLED',
  }

  export type GasFilterFormBaseValue = string
    | string[]
    | number
    | number[]
    | boolean
    | boolean[]
    | Record<string, unknown>
    | Record<string, unknown>[]
    | Date
    | Date[];
}
